import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow-right",
  "use": "icon-arrow-right-usage",
  "viewBox": "0 0 32 33",
  "content": "<symbol viewBox=\"0 0 32 33\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-arrow-right\"><path d=\"M27.9 16.9C28 16.7 28 16.4 27.9 16.1C27.8 16 27.8 15.9 27.7 15.8L18.7 6.8C18.3 6.4 17.7 6.4 17.3 6.8C16.9 7.2 16.9 7.8 17.3 8.2L24.6 15.5H5C4.4 15.5 4 15.9 4 16.5C4 17.1 4.4 17.5 5 17.5H24.6L17.3 24.8C16.9 25.2 16.9 25.8 17.3 26.2C17.5 26.4 17.8 26.5 18 26.5C18.2 26.5 18.5 26.4 18.7 26.2L27.7 17.2C27.8 17.1 27.9 17 27.9 16.9Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol